/*
 * Font Awesome styling for the AI icon component
 * This is a subset of the font-awesome styles needed for the magic wand sparkles icon
 */

:host {
  display: inline-block;
  vertical-align: middle;
}

:host(.disabled) {
  opacity: 0.3;
}
